import { kTriAnnoW } from "../constants";
import { SVG_DrawTri } from "./SVG_DrawTri";
import { SVG_DrawAnnoLabel } from "./SVG_DrawAnnoLabel";

export function SVG_RenderAnno(
  bounds,
  boxShape,
  triColor,
  dashColor,
  subTriColor,
  annoLabel,
  triPosition,
  borderColor,
  borderThickness,
  svgElement
) {
  SVG_DrawTri(
    bounds,
    boxShape,
    borderThickness,
    triColor,
    triPosition,
    borderColor,
    dashColor,
    subTriColor,
    svgElement
  );
  if (annoLabel) SVG_DrawAnnoLabel(annoLabel, bounds, kTriAnnoW, triColor, triPosition, svgElement);
}
